
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Hotel as HotelType } from "@/types/hotel";
import { Hotel, MapPin, Star } from "lucide-react";

interface HotelsGridProps {
  hotels: HotelType[];
  onSelectHotel: (hotel: HotelType) => void;
}

export const HotelsGrid = ({ hotels, onSelectHotel }: HotelsGridProps) => {
  return (
    <ScrollArea className="h-72">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pr-4">
        {hotels.length > 0 ? hotels.map(hotel => (
          <Card key={hotel.id} className="cursor-pointer hover:border-blue-500 transition-colors overflow-hidden flex flex-col" onClick={() => onSelectHotel(hotel)}>
            {hotel.image_url ? (
                <img src={hotel.image_url} alt={hotel.name_ar} className="w-full h-32 object-cover" />
            ) : (
                <div className="w-full h-32 bg-gray-100 flex items-center justify-center">
                    <Hotel className="w-10 h-10 text-gray-400" />
                </div>
            )}
            <div className="p-4 flex-grow">
              <CardHeader className="p-0">
                <CardTitle className="text-base">{hotel.name_ar}</CardTitle>
                <CardDescription className="flex items-center gap-2 pt-1">
                  <MapPin className="w-3 h-3"/> {hotel.city}, {hotel.country}
                </CardDescription>
              </CardHeader>
              <CardContent className="p-0 mt-auto pt-2">
                <div className="flex items-center gap-1">
                  {Array.from({ length: hotel.stars }).map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />)}
                </div>
              </CardContent>
            </div>
          </Card>
        )) : <p className="col-span-full text-center text-gray-500 py-8">لا توجد فنادق تطابق البحث. يرجى اختيار دولة ومدينة أو إضافة فندق جديد.</p>}
      </div>
    </ScrollArea>
  );
};
